module.exports = __webpack_public_path__ + "img/BlockInternetPolicy_EN.77153fcf.png";